import clickOutside from "./clickOutside";
import tooltip from "./tooltip";
import access from "./access";

export default {
  install(Vue) {
    Vue.directive("click-outside", clickOutside);
    Vue.directive("tooltip", tooltip);
    Vue.directive("access", access);
  },
};
